<template>
    <div class="out-of-stock-wrapper">
        <p id="out-of-stock-label"
            class="out-of-stock-wrapper__label"
        >
            {{ $t('global.outOfStock') }}
        </p>
    </div>
</template>

<style lang="scss" scoped>
.out-of-stock-wrapper {
    display: flex;
    flex-direction: column;

    &__label {
        color: $white-color;
        font-size: 1.5rem;
        text-transform: uppercase;
        font-family: "Monument";
        font-weight: 900;
    }
}
</style>

<script>
export default {
    name: 'out-of-stock',
};
</script>